import script from "./MiniDeformationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniDeformationSettings.vue?vue&type=script&setup=true&lang=js"

import "./MiniDeformationSettings.vue?vue&type=style&index=0&id=77581042&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77581042"]])

export default __exports__